import { ModalPopup, Stack } from 'components';

import style from './expanded.module.scss';
import { useAiScribeContext } from '../../context/useAiScribe';
import IdleScreen from './idleScreen/idleScreen';
import RecordingScreen from './recordingScreen/recordingScreen';
import TranscribingScreen from './transcribingScreen/transcribingScreen';

const Expanded = () => {
  const { state, status, handleDrawerClose } = useAiScribeContext();

  const getIconClose = () => {
    if (status === 'recording') return 'remove';
    if (status === 'transcribing' || status === 'transcribed') return 'close';
    return 'close';
  };

  return (
    <ModalPopup
      open={state === 'expanded'}
      customClassInsideContainer={style.modal}
      customClassModalContentContainer={style.contentContainer}
      customClassCloseIconContainer={style.closeIconContainer}
      handleClose={handleDrawerClose}
      iconClose={getIconClose()}
    >
      <Stack height="100%" width="100%">
        {status === 'idle' && <IdleScreen />}
        {status === 'recording' && <RecordingScreen />}
        {(status === 'transcribing' || status === 'transcribed') && <TranscribingScreen />}
      </Stack>
    </ModalPopup>
  );
};

export default Expanded;
